import { useLoadUpProxiesMutation, useUpdatePasswordsMutation } from "@RTKQuery/admin/proxy/proxy";
import { Button } from "@ui";
import { useEffect } from "react";
import cn from "classnames";
import style from "./Buttons.module.scss";

export function Buttons() {
    const [loadUpProxies, loadUpProxiesStatus] = useLoadUpProxiesMutation();
    const [updatePasswords, updatePasswordsStatus] = useUpdatePasswordsMutation();

    useEffect(() => {
        if (loadUpProxiesStatus.isSuccess) {
            loadUpProxiesStatus.reset()
        }
    }, [loadUpProxiesStatus])

    return (
        <div className={style.container}>
            <Button
                color="orange"
                form="ellipse"
                text="Оновити список"
                icon={<UpdateIcon className={cn(loadUpProxiesStatus.isLoading && "animate-spin")} />}
                customStyle={{
                    button: style.customBtn,
                }}
                errors={[
                    (loadUpProxiesStatus.error && ((extractError) => {
                        return extractError(loadUpProxiesStatus.error)
                    }))
                ]}
                onClick={() => {
                    loadUpProxies();
                }}
                resetStatus={() => {
                    loadUpProxiesStatus.reset();
                }}
            />
            <Button
                color="orange"
                form="ellipse"
                text="Оновити паролі"
                icon={<UpdateIcon className={cn(updatePasswordsStatus.isLoading && "animate-spin")} />}
                customStyle={{
                    button: style.customBtn,
                }}
                errors={[
                    (updatePasswordsStatus.error && ((extractError) => {
                        return extractError(updatePasswordsStatus.error)
                    }))
                ]}
                successContent={
                    updatePasswordsStatus.isSuccess
                        ? {
                            title: "Вітаємо!",
                            description: <p className="max-w-[260px]">Ви успішно оновили паролі!</p>
                        }
                        : undefined
                }
                onClick={() => {
                    updatePasswords();
                }}
                resetStatus={() => {
                    updatePasswordsStatus.reset();
                }}
            />
        </div>
    )
}

function UpdateIcon({ className }: { className: string }) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
            <g clipPath="url(#clip0_2339_22559)">
                <path d="M9.16138 3.46775L8.75956 3.05646C6.98447 1.23926 4.10646 1.23926 2.33134 3.05646C0.556219 4.87365 0.556219 7.81992 2.33134 9.63711C4.10646 11.4543 6.98447 11.4543 8.75956 9.63711C9.79184 8.58038 10.2238 7.14174 10.0556 5.76546M9.16138 3.46775H6.75074M9.16138 3.46775V1" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2339_22559">
                    <rect width="11" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}